import { ApiStore, Widget, rotationModes } from '@hart-estate/widget';
import '../assets/sass/index.sass';
import logo from '../assets/img/logo.png';

const WIDGET_API_URL = 'https://backend.estate.hart-digital.com';

const createWidget = async (logoUrl) => {
  const widgetApiHandler = new ApiStore(WIDGET_API_URL)

  const searchParams = (new URL(document.location)).searchParams;
  const planId = searchParams.get("id");

  const planData = await widgetApiHandler.loadWidgetData(planId);
  const options = {
    ...planData.parsed,
    API_URL: WIDGET_API_URL,
    rotationMode: rotationModes.DEFAULT,
    logo: logo,
    tabs: ['panorama', 'rotation'],
    locale: 'en',
    logoUrl,
    dictionaryOverrides: {
      'made-by-text': 'sustech',
      'made-by-link': 'https://sustech.edu.cn/',
    },
    enableCameraTransitionBetweenPanoramas: false,
    enableGyroscope: false
  }

  new Widget('#widget', options);
}

createWidget('https://sustech.edu.cn/');
